<script lang="ts">
	import ProfileConcertRow from '$lib/profile/ProfileConcertRow.svelte';
	import ProfileConcertRowDark from '$lib/profile-dark/ProfileConcertRow-dark.svelte';

	import Icon from '$lib/icon.svelte';
	import { popup } from '@skeletonlabs/skeleton';
	import type { PopupSettings } from '@skeletonlabs/skeleton';

	const popupHover: PopupSettings = {
		event: 'hover',
		target: 'popupHover',
		placement: 'bottom'
	};

	//import posthog from 'posthog-js';

	import { onMount } from 'svelte';
	import { enhance } from '$app/forms';

	let dark = false;  // Initialize dark as false
	let form: HTMLFormElement;
	let isLoading = true;
	//let clientUser: {slug: string, isOwner: boolean} = { slug: '', isOwner: false };
	let clientUser: {slug: string, isOwner: boolean, isCreatorProUnlimited: boolean} = { slug: '', isOwner: false, isCreatorProUnlimited: false };
	

	export let data;

	onMount(() => {
		console.log('1. onMount started'); // First checkpoint


		//dark mode check
		try {
			// Get the current URL parameters
			console.log('2. Checking dark mode');
			const currentUrl = new URL(window.location.href);
			dark = currentUrl.searchParams.get('theme') === 'dark';
			console.log('Theme parameter:', currentUrl.searchParams.get('theme')); // For debugging
		} catch (e) {
			console.log('Unable to access URL parameters:', e);
		}
		// let cookiesRaw = document.cookie;
		// let cookiesArray =  cookiesRaw.split(';')
		// console.log("Cookie Array:", cookiesArray);
		console.log('4. Starting cookie check');
		let cookiesRaw = document.cookie;
		const cookiesArray =  cookiesRaw.split(';')
		// console.log("VC - cookie array", cookiesArray);
		console.log('5. Cookie array:', cookiesArray);
    	// const soundCloudRawAuth = cookiesArray.find(cookie => cookie.trim().startsWith("ajs_user_id=")) || '';
		const soundCloudRawAuth = cookiesArray.find(cookie => cookie.trim().startsWith("sc_tracking_user_id=")) || '';
		console.log('6. Found auth cookie:', !!soundCloudRawAuth);

		const setClientUserSlug = async (cookie_string: string) => { 

			const regexSearchForID = soundCloudRawAuth.match(/(?<=3A)\d+(?=%22)/);
			console.log("regex searching", regexSearchForID);
			const clientUserID = regexSearchForID[0];
			const getUserById = async (user_Id: string) => { 
				try {
					// console.log("beginning vc fetch");
					let soundCloudAuthRequest = await fetch('https://xx0m-bb7z-1xmi.n7c.xano.io/api:kYvy_mr_/soundcloud_xano_auth');
					let soundCloudUserToken = (await soundCloudAuthRequest.text()).replace(/^["']|["']$/g, '');
					// console.log("token", soundCloudUserToken);
					let soundCloudUserData = await fetch(`https://api.soundcloud.com/users/${clientUserID}`, {
				      headers: {
				        "Authorization": `OAuth ${soundCloudUserToken}`,
				      },
				    });
					// console.log("fetch complete");
					let response = await soundCloudUserData.json();

					if (Array.isArray(response.subscriptions)) {
						clientUser.isCreatorProUnlimited = response.subscriptions.some(sub => sub?.product?.id === "creator-pro-unlimited");
						// console.log("🎯 Final subscription result:", clientUser.isCreatorProUnlimited);
					}

					clientUser.slug = response.permalink;
					console.log("🎯 Slug:", clientUser.slug);
					console.log("🎯 Data slug:", data.slug);
					if(response.permalink === data.slug){ 
						clientUser.isOwner = true; 
						// console.log('User authenticated - velvet cake')
					}
					else{ 
						clientUser.isOwner = false; 
						// console.log('user authenticated but this use is not owner  - velvet cake');
					}

					clientUser.artistId = response.id;
					// console.log("🎯 ID:", clientUser.artistId);
					isLoading = false;
				}
				catch (err){ 
					// console.log("user not authenticated", err);
					clientUser.isOwner = false; 

					// throw Error(
					// 	500,
	     			// 	err.message,
					// )
				}
			}
			if(regexSearchForID && clientUserID) await getUserById(clientUserID)
			else clientUser.isOwner = false;

			// HEIGHT STARTS HERE
			if (data.iframeFrontendStatus === 'HIDE') {
				// @FIX before production, send only to soundcloude not * broadcast
				// Want min height of 136, so we can fit the info text
				if (clientUser.isOwner) {
					window.parent.postMessage({ height: 150 }, '*');
				} else {
					// window.parent.postMessage({ height: 96 }, '*');
					window.parent.postMessage({ height: 0 }, '*');
				}
				// window.parent.postMessage({ height: 0 }, '*');
			} else {
				// @FIX before production, send only to soundcloude not * broadcast
				let height;
				if (clientUser.isOwner) {
					switch (data.concerts.length) {
						case 3:
							// old height = 220;
							height = 314; // with text and CTA
							// height = 220; // original height
							// height = 274; // with text, no CTA
							break;
						case 2:
							// old height = 159;
							height = 253; // with text and CTA
							// height = 159; // original height
							// height = 213; // with text, no CTA
							break;
						case 1:
							// A little taller than content to allow for the tool tip
							// old height = 111;
							height = 205; // with text and CTA
							// height = 111; // original height
							// height = 165; // with text, no CTA
							break;
						default:
							// old height = 0;
							// height = 136; // with text and CTA
							window.parent.postMessage({ height: 150 }, '*');
							// window.parent.postMessage({ height: 96 }, '*');
					}
				} else {
					switch (data.concerts.length) {
						case 3:
							// old height = 220;
							// height = 314; // with text and CTA
							height = 220; // original height
							// height = 274; // with text, no CTA
							break;
						case 2:
							// old height = 159;
							// height = 253; // with text and CTA
							height = 159; // original height
							// height = 213; // with text, no CTA
							break;
						case 1:
							// A little taller than content to allow for the tool tip
							// old height = 111;
							// height = 205; // with text and CTA
							// height = 111; // original height
							height = 150; // min height
							// height = 165; // with text, no CTA
							break;
						default:
							// old height = 0;
							// height = 136; // with text and CTA
							window.parent.postMessage({ height: 150 }, '*');
							// window.parent.postMessage({ height: 96 }, '*');
					}
				}
				window.parent.postMessage({ height }, '*');
				// console.log("🎯 Is Hidden:", data.iframeFrontendStatus === 'HIDE');
				// console.log("🎯 Is Owner:", clientUser.isOwner);
			}

			// HEIGHT ENDS HERE
			console.log("🎯 Height:", height);
		}

		// Original height section starts here
		/*
		if (data.iframeFrontendStatus === 'HIDE') {
			// @FIX before production, send only to soundcloude not * broadcast
			if (clientUser.isOwner) {
				window.parent.postMessage({ height: 136 }, '*');
			} else {
				// window.parent.postMessage({ height: 96 }, '*');
				window.parent.postMessage({ height: 136 }, '*');
			}
			// window.parent.postMessage({ height: 0 }, '*');
		} else {
			// @FIX before production, send only to soundcloude not * broadcast
			let height;
			// if (clientUser.isOwner) {
			switch (data.concerts.length) {
				case 3:
					// old height = 220;
					height = 314; // with text and CTA
					// height = 220; // original height
					// height = 274; // with text, no CTA
					break;
				case 2:
					// old height = 159;
					height = 253; // with text and CTA
					// height = 159; // original height
					// height = 213; // with text, no CTA
					break;
				case 1:
					// A little taller than content to allow for the tool tip
					// old height = 111;
					height = 205; // with text and CTA
					// height = 111; // original height
					// height = 165; // with text, no CTA
					break;
				default:
					// old height = 0;
					// height = 136; // with text and CTA
					window.parent.postMessage({ height: 136 }, '*');
					// window.parent.postMessage({ height: 96 }, '*');
			}
			*/
			/*
			} else {
				switch (data.concerts.length) {
					case 3:
						// old height = 220;
						// height = 314; // with text and CTA
						height = 220; // original height
						// height = 274; // with text, no CTA
						break;
					case 2:
						// old height = 159;
						// height = 253; // with text and CTA
						height = 159; // original height
						// height = 213; // with text, no CTA
						break;
					case 1:
						// A little taller than content to allow for the tool tip
						// old height = 111;
						// height = 205; // with text and CTA
						height = 111; // original height
						// height = 165; // with text, no CTA
						break;
					default:
						// old height = 0;
						// height = 136; // with text and CTA
						// window.parent.postMessage({ height: 136 }, '*');
						window.parent.postMessage({ height: 96 }, '*');
				}
			}
			*/
			/*
			window.parent.postMessage({ height }, '*');
			// console.log("🎯 Is Hidden:", data.iframeFrontendStatus === 'HIDE');
		}
		*/
		// Original height section ends here


		// Only capture seen when the person actually sees it
		/*
		if (data.iframeFrontendStatus != 'HIDE') {
			posthog.capture('$pageview', {
				page_type: 'artist-profile',
				artist: data.slug,
				auth_status: data.authStatus
			});
		}
		*/
		if(soundCloudRawAuth) setClientUserSlug(soundCloudRawAuth); 

	});

	const clientKey = 'uvxWUD1bAoz72xdGZddLo8F7KX0GSidO';

	const authUrl = `https://secure.soundcloud.com/authorize?client_id=${clientKey}&redirect_uri=localhost:5173&response_type=code&state=STATE`;

	const goToEditPage = () => { 
    	window.open(`https://soundcloudevents.velvetcake.live?artist=${data.slug}`, '_blank');
	}

	/*
	const goToEditPageArtistId = () => { 
    	window.open(`https://soundcloudevents.velvetcake.live?fwd=${data.id}`, '_blank');
	}*/
	const goToEditPageArtistId = () => { 
		if (clientUser.artistId) {
			window.open(`https://soundcloudevents.velvetcake.live?fwd=${clientUser.artistId}`, '_blank');
		}
	}

	const goToSubscribePage = () => { 
	window.open(`https://checkout.soundcloud.com/artist/buy/artist-pro?ref=t10440`, '_blank');
	}

	// const setClientUserSlug = async (cookie_string: string) => { 
	// 	const regexSearchForID = soundCloudRawAuth.match(/(?<=3A)\d+(?=%22)/);
	// 	const clientUserID = regexSearchForID[0];
	// 	const getUserById = async (user_Id: string) => { 
	// 		try {
	// 			let soundCloudUserData = await fetch(`https://api.soundcloud.com/users/${clientUserID}`)
	// 			let response = await soundCloudUserData.json();
	// 			clientUser.slug = response.permalink;
	// 			if(response.permalink === data.slug){ 
	// 				clientUser.isOwner = true; 
	// 				console.log('user authenticated - velvet cake')
	// 			}
	// 			else{ 
	// 				clientUser.isOwner = false; 
	// 			}

	// 		}
	// 		catch (err){ 
	// 			console.log("user not authenticated", err);
	// 			// throw Error(
	// 			// 	500,
    //  			// 	err.message,
	// 			// )
	// 		}
	// 	}
	// 	if(regexSearchForID && clientUserID) await getUserById(clientUserID)
	// 	else clientUser.isOwner = false; 

	// }

</script>

<!-- Header -->
<div class={`flex items-center justify-between gap-1.5 border-b text-[14px] text-[#959595] ${dark ? 'bg-[#121212]' : 'bg-white'}`}>
	<div class="flex items-center gap-1.5 py-2">
		<Icon type="ticket" class="mb-0.5 ml-1 h-[12px] stroke-[#121212]" />

		<p 
			class="font-semibold leading-[0px]" 
			style={`font-family: 'Inter', sans-serif; font-size: 12px; color: ${dark ? '#FFFFFF' : '#121212'}; text-transform: uppercase; font-weight: 700;`}
		>
			On tour
		</p>
		<!--<p class="font-semibold leading-[0px]" style="font-family: 'Inter', sans-serif; font-size: 12px; color: #121212; text-transform: uppercase; font-weight: 700;">On tour</p>-->
		<div use:popup={popupHover}>
			<Icon
				type="info"
				class="mb-[1px] h-[16px]  stroke-[#959595] hover:stroke-black [&>*]:pointer-events-none"
			/>
		</div>
	</div>
	<div
		class="z-50 mt-1 max-w-[270px] border border-[#D6D6D6] bg-white p-4"
		data-popup="popupHover"
	>
		{#if clientUser.isOwner === true}
			{#if data.iframeFrontendStatus === 'HIDE'}
				<p class="text-[14px] leading-snug text-[#121212]">
					Add your upcoming events to SoundCloud, and fans will be able to view them here.
				</p>
			{:else}
				<p class="text-[14px] leading-snug text-[#121212]">
					Tour information is matched based on your artist name.
				</p>
			{/if}
		{:else}
			{#if clientUser.isCreatorProUnlimited === true}
				<p class="text-[14px] leading-snug text-[#121212]">
					With an Artist Pro account, you can create ticketed live events from your SoundCloud profile page.
				</p>
			{:else}
				<p class="text-[14px] leading-snug text-[#121212]">
					With an <span class="underline" on:click={() => goToSubscribePage()}>Artist Pro account</span>, you can create ticketed live events from your SoundCloud profile page.
				</p>
			{/if}
		{/if}
		<div class="arrow !-top-[7px] !h-3 !w-3 border-l border-t border-[#D6D6D6] bg-white" />
	</div>

	<!--
	{#if clientUser.isOwner === true}
		<style>
			.edit-button-text-underline:hover {
				text-decoration: underline;
				text-decoration-color: #757575;
			}
		</style>
		<button
			class="btn btn-sm !bg-transparent pl-0 font-semibold text-surface-100"
			on:click={() => goToEditPage()}
			>
			<p class="font-semibold leading-[0px] text-right edit-button-text-underline" style="font-family: 'Inter', sans-serif; font-size: 12px; color: #757575;">Edit</p>
		</button>
	{/if}
	-->

</div>

<!-- Body -->
<div class={`${dark ? 'bg-[#121212]' : 'bg-white'}`}>
	{#if data.iframeFrontendStatus === 'SHOW' || data.iframeFrontendStatus === 'SHOW_HIDE'}
		<div class={data.iframeFrontendStatus === 'SHOW_HIDE' ? 'opacity-50' : ''}>
			{#if dark}
				<ProfileConcertRowDark concerts={data.concerts} />
			{:else}
				<ProfileConcertRow concerts={data.concerts} />
			{/if}
		</div>
	{/if}

	{#if clientUser.isOwner === true}
		{#if clientUser.isCreatorProUnlimited === true}
			{#if data.iframeFrontendStatus === 'HIDE'}
				<div class="pt-4 pb-3">
					<p class={`text-[11px] font-semibold ${dark ? 'text-[#ebebeb]' : 'text-[#909090]'} group-hover:text-black leading-tight`}>As an Artist Pro subscriber, you can create ticketed live events on SoundCloud, and list existing events.</p>
				</div>
				<button 
					class="mt-4 mb-3 min-w-[300px] max-w-[330px] w-full h-[40px] bg-[#F5F5F5] rounded-[24px] px-4 py-2 font-inter font-bold text-[14px] text-center text-[#121212] disabled:opacity-50" 
					on:click={() => goToEditPageArtistId()}
					disabled={isLoading}>
					{isLoading ? 'Loading...' : 'Add Events'}
				</button>
			{:else}
				<button 
					class="mt-4 mb-3 min-w-[300px] max-w-[330px] w-full h-[40px] bg-[#F5F5F5] rounded-[24px] px-4 py-2 font-inter font-bold text-[14px] text-center text-[#121212] disabled:opacity-50" 
					on:click={() => goToEditPageArtistId()}
					disabled={isLoading}>
					{isLoading ? 'Loading...' : 'Manage Events'}
				</button>
				<div>
					<p class={`text-[11px] font-semibold ${dark ? 'text-[#ebebeb]' : 'text-[#909090]'} group-hover:text-black leading-tight`}>As an Artist Pro subscriber, you can create ticketed live events on SoundCloud, and list existing events.</p>
				</div>
			{/if}
		{:else}
			{#if data.iframeFrontendStatus === 'HIDE'}
				<div class="pt-4 pb-3">
					<p class={`text-[11px] font-semibold ${dark ? 'text-[#ebebeb]' : 'text-[#909090]'} group-hover:text-black leading-tight`}>With an Artist Pro account, you can create ticketed live events on SoundCloud, and list existing events.</p>
				</div>
				<button class="min-w-[300px] max-w-[330px] w-full h-[40px] bg-[#F5F5F5] rounded-[24px] px-4 py-2 font-inter font-bold text-[14px] text-center text-[#121212] disabled:opacity-50 mb-[20px]" on:click={() => goToSubscribePage()}>
					Upgrade to Artist Pro
				</button>
			{:else}
				<button class="mt-4 mb-3 min-w-[300px] max-w-[330px] w-full h-[40px] bg-[#F5F5F5] rounded-[24px] px-4 py-2 font-inter font-bold text-[14px] text-center text-[#121212] disabled:opacity-50" on:click={() => goToSubscribePage()}>
					Upgrade to Artist Pro
				</button>
				<div>
					<p class={`text-[11px] font-semibold ${dark ? 'text-[#ebebeb]' : 'text-[#909090]'} group-hover:text-black leading-tight`}>With an Artist Pro account, you can create ticketed live events on SoundCloud, and list existing events.</p>
				</div>
			{/if}
		{/if}
	{:else}
		{#if data.iframeFrontendStatus === 'HIDE'}
			<div>
				<p class={`mt-4 mb-3 text-[11px] font-semibold ${dark ? 'text-[#ebebeb]' : 'text-[#909090]'} group-hover:text-black leading-tight`}>There are no upcoming SoundCloud events for this artist.</p>
			</div>
		{/if}
	{/if}
	
	<div class="my-[80px]">
		<p class={`mt-4 mb-3 text-[11px] font-semibold ${dark ? 'text-[#ebebeb]' : 'text-[#909090]'} group-hover:text-black leading-tight`}>Powered by Velvet Cake.</p>
	</div>
	<!--
	{#if clientUser.isOwner === true}
		<div class="mt-8 mb-3">
			<button class="w-[300px] h-[40px] bg-[#F5F5F5] rounded-[24px] px-4 py-2 font-inter font-bold text-[14px] text-center text-[#121212]" on:click={() => goToEditPage()}>
				Add Events
			</button>
		</div>
	{/if}
	-->
</div>